import { NgModule } from '@angular/core';
import { PaginationComponent } from './pagination.component';
import { MaterialComponentsModule } from '../../material.module';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../../pipes/pipes.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    PaginationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialComponentsModule,
    PipesModule
  ],
  exports: [
    PaginationComponent
  ]
})
export class PaginationModule { }
